// @core/api/endpoints/tenant/update_tenant_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantSettingsResponse,
  UpdateTenantSettingsRequest,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Update tenant settings (including privacy)
 * Updates tenant settings such as privacy level, visibility in directory, and feature toggles. Changes take effect immediately and may affect member access.
 */
export async function UpdateTenantSettings(
  tenant_id: string,
  data: UpdateTenantSettingsRequest,
  options?: RequestOptions
): Promise<TenantSettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/settings`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.put<TenantSettingsResponse>(requestPath, data, requestOptions);
}
